// Translation: Turkish > Status
const status = Object.freeze({
	loadingData: 'Veriler yükleniyor',
	updatingData: 'Veriler güncelleniyor'
})

// Export
export default status
